export default __webpack_public_path__ + "static/Topland_blue-a7a498d166b910980fb72c9f6e141c4f.png";